<!--
 * @Author: your name
 * @Date: 2021-11-09 15:47:03
 * @LastEditTime: 2021-11-22 10:29:40
 * @LastEditors: Please set LastEditors
 * @Description: 
 * @FilePath: \gao-jing\src\views\components\practiceLog.vue
-->
<template>
 <div v-loading='loading' class="content-two">
  <div class="practiceLog">
    <div class="right_top">
      <div
        class="infinite-list daily_list"
        v-if="logList && logList.length > 0"
        v-infinite-scroll="loadList"
      >
        <div
          class="
            infinite-list-item
            daily_item
            animate__animated animate__fadeIn
          "
          v-for="(item, index) in logList"
          :key="index"
          @click="getLog(item.id)"
        >
          <div class="item_top">
            <img class="headPhoto" :src="item.userAvatar" alt="" />
            <div>
              <p class="user_name">
                {{ item.userName
                }}<span
                  ><img class="school_img" :src="item.userUniversityLogoUri" alt="" />{{
                    item.userUniversity
                  }}</span
                >
              </p>
              <p class="user_inte">{{ item.team }}</p>
            </div>
            <div class="user_time" v-time="item.creationTime"></div>
          </div>
          <div class="daily_content">
            {{ item.title }}
          </div>
          <div
            class="daily_bottom"
            v-if="item.imgUris !== undefined && item.imgUris.length > 0"
          >
            <div
              class="daily_img"
              v-for="(imgItem, index) in item.imgUris"
              :key="index"
            >
              <el-image
                style="width: 100%; height: 100%"
                :src="imgItem"
                fit="cover"
                lazy
              ></el-image>
            </div>
          </div>
        </div>
      </div>
      <div class="noDate" v-else>暂无日志~</div>
      <!-- <div class="modal_prop" v-if="logList && logList.length > 0"></div> -->
    </div>

    <div class="log_modal" v-if="logModal">
      <img
        class="log_close"
        src="https://univteam-imageserver.oss-cn-qingdao.aliyuncs.com/ClassMS/Images/202110291045042331.svg"
        alt=""
        @click="closeLog"
      />
      <div class="user_box">
        <div v-if="GrowthLog.coverImageUri">
          <el-image
            class="bannner_log"
            :src="GrowthLog.coverImageUri"
            fit="cover"
          
            v-if="suffix !== 'MOV' && suffix !== 'mp4' && suffix !== 'mov'"
          ></el-image>
          <video
            class="banner_video"
            v-else
            :src="GrowthLog.coverImageUri"
          ></video>
        </div>
        <div class="user_box_log">
          <p class="log_tit">{{ GrowthLog.title }}</p>
          <div class="log_date">
            <div class="log_date_left">
              <span>{{ startDate[0] }}</span
              >年 <span>{{ startDate[1] }}</span
              >月 <span>{{ startDate[2] }}</span
              >日
            </div>
            <div class="log_date_right" v-if="GrowthLog.skillName">
              <span class="iconfont iconlujing3"></span>
              {{ GrowthLog.skillName }}
            </div>
          </div>
          <div class="log_info">
            <img
              class="user_img"
              v-if="GrowthLog.userAvatar"
              :src="GrowthLog.userAvatar + '?x-oss-process=style/avatar'"
              alt=""
            />
            <div class="user_info">
              <p class="name">
                <span>{{ GrowthLog.userName }}</span
                ><span class="iconfont iconHCV"></span
                ><b>{{ parseInt(GrowthLog.userHCV) }}</b>
              </p>
              <p class="info">
                {{ GrowthLog.userUniversity }} {{ GrowthLog.userEntryYear }}级
                {{ GrowthLog.userEducationName }}
              </p>
            </div>
            <div class="log_time">
              <span class="iconfont iconpen"></span
              >{{ GrowthLog.creationTime | toconvertDate }}
            </div>
          </div>
        </div>
      </div>
      <div class="fenge">
        <div>正文</div>
        <div class="dashed"></div>
      </div>
      <div class="log_content">
        <div
          class="readMe"
          v-for="(item, index) in hrDescribeArr"
          :key="item.id"
        >
          <div class="readMeText" v-if="item.type == 1">
            <div v-html="item.content"></div>
          </div>
          <div class="readMeImg" v-else-if="item.type == 2">
            <img
              :src="item.content + '?x-oss-process=style/content'"
              alt=""
              @click="bigImg(item, index)"
            />
          </div>
          <div v-else-if="item.type == 3" class="video_box">
            <video
              :id="`video${index}`"
              width="100%"
              :poster="
                item.content +
                '?x-oss-process=video/snapshot,t_1000,f_jpg,w_750,m_fast'
              "
              x5-video-player-type="h5"
              :src="item.content"
              style="
                width: 100%;
                object-fit: cover;
                object-position: top;
                border-radius: 5px;
              "
            ></video>
            <div class="playVideo2" :id="`poster2${index}`">
              <em
                id="poster2"
                class="iconfont iconplay"
                @click="play2(index)"
              ></em>
            </div>
            <div class="video_title">
              <div class="video_title_content">{{ item.title }}</div>
            </div>
          </div>
          <div v-else-if="item.type == 4">
            <div
              class="MsEditM-attach"
              :class="{
                xls:
                  item.fileType == '.xls' ||
                  item.fileType == '.xlsx' ||
                  item.fileType == '.csv' ||
                  item.fileType == '.xlsm',
                doc: item.fileType == '.doc' || item.fileType == '.docx',
                ppt: item.fileType == '.ppt' || item.fileType == '.pptx',
                pdf: item.fileType == '.pdf',
                zip:
                  item.fileType == '.zip' ||
                  item.fileType == '.rar' ||
                  item.fileType == '.7z',
                txt: item.fileType == '.txt',
              }"
            >
              <a
                :href="item.content"
                target="_blank"
                @click="download(item.content)"
              >
                <div class="MsEditM-attach-title">
                  <span>{{ item.name }}</span>
                </div>
                <div class="MsEditM-attach-subtitle">
                  <span class="size">文件大小:{{ item.size | formatSize }}</span
                  ><span class="type">类型: {{ item.fileType }}</span>
                </div>
              </a>
            </div>
          </div>
          <div class="main" v-else-if="item.type == 5">
            <audio :src="item.content" controls="controls">
              <div class="MsEditM-attach">
                <div class="MsEditM-attach-title">
                  <span>{{ item.name }}</span>
                </div>
              </div>
            </audio>
            <div class="voiceText">
              {{ item.voiceText }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="shade_pop animate__animated animate__fadeIn" v-if="modal"></div>
  </div>
  </div>
</template>

<script>
import "../../src/util/time";
export default {
  filters: {
    toconvertDate(value) {
      var result = "";
      var minute = 1000 * 60;
      var hour = minute * 60;
      var day = hour * 24;
      var month = day * 30;
      var now = new Date().getTime();
      let newDate = value.replace(/-/g, "/");
      var yiqian = new Date(newDate).getTime();
      var diffValue = now - yiqian;
      if (diffValue < 0) return;
      var monthC = diffValue / month;
      var weekC = diffValue / (7 * day);
      var dayC = diffValue / day;
      var hourC = diffValue / hour;
      var minC = diffValue / minute;
      if (monthC >= 1) {
        result = "" + parseInt(monthC) + "月前";
      } else if (weekC >= 1) {
        result = "" + parseInt(weekC) + "周前";
      } else if (dayC >= 1) {
        result = "" + parseInt(dayC) + "天前";
      } else if (hourC >= 1) {
        result = "" + parseInt(hourC) + "小时前";
      } else if (minC >= 1) {
        result = "" + parseInt(minC) + "分钟前";
      } else {
        result = "刚刚";
      }
      return result;
    },

    toThousand(num) {
      if (num > 10000) {
        return Math.floor((num / 10000) * 100) / 100 + "万";
      } else {
        return num;
      }
    },
    formatSize(size) {
      if (size > 1024 * 1024 * 1024) {
        return Math.floor((size * 100) / (1024 * 1024 * 1024)) / 100 + "G";
      } else if (size > 1024 * 1024) {
        return Math.floor((size * 100) / (1024 * 1024)) / 100 + "M";
      } else if (size > 1024) {
        return Math.floor((size * 100) / 1024) / 100 + "kb";
      } else {
        return Math.floor(size * 100) / 100 + "b";
      }
    },
  },
  data() {
    return {
      modal:false,
      logList: [],

      // 日志详情
      GrowthLog: {},
      logModal: false,

      pageIndex: 1,
      isDisabledList: false,

      // 文字数
      characterCount: 0,
      // 日志数
      logCount: 0,
      loading:false,
    };
  },
  mounted() {
    this.ppcId = this.$route.query.ppcId;
    this.tagId = this.$route.query.tagId;
    // this.ppcId = 11;
    // this.tagId = 17958;
    this.loadPage();
  },
  methods: {
    loadList() {
      this.loading=true;
      let para = {
        pageIndex: this.pageIndex,
        pageSize: 10,
        ppcId: this.ppcId,
        tagId: this.tagId,
      };

      this.$api.social.getGrowthLogHot(para).then((res) => {
        console.log(res);
        let data = res.data;
        this.loading=false;
        if (data && data.length) {
          data.forEach((el) => {
            this.logList.push(el);
          });

          this.pageIndex = this.pageIndex + 1;
        } else {
          this.isDisabledList = true;
        }
      });
    },
    loadPage() {
      this.loadList();

      let para = {
        ppcId: this.ppcId,
        tagId: this.tagId,
      };
      this.$api.social.getLogStatistics(para).then((res) => {
        console.log(res);
        let data = res.data;
        this.logCount = data.logCount;
        this.characterCount = data.characterCount;
      });
    },

    getLog(id) {
      this.modal=true;
      this.getGrowthLog(id);
    },
    //获取日志详情
    getGrowthLog(id) {
      this.$api.social.getGrowthLog(id).then((response) => {
        if (response.status == 204) {
          this.$dialog
            .alert({
              message: "当前日志不存在或已删除",
            })
            .then(() => {
              //关闭弹窗
            });
        }
        this.GrowthLog = response.data;
        this.hrDescribeArr = response.data.content;
        if (response.data.coverImageUri) {
          this.suffix = response.data.coverImageUri.substring(
            response.data.coverImageUri.lastIndexOf(".") + 1
          );

        }
        this.startDate = this.GrowthLog.startDate.split(" ")[0];
        this.startDate = this.startDate.split("-");
        this.logModal = true;
      });
    },

    closeLog() {
      this.modal=false;
      this.logModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.practiceLog {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-height: 800px;
  // height: 100vh;
  padding-right: 10px;
  overflow: auto;
  .right_top {
    height: auto;
    border-radius: 10px;
    position: relative;
    .daily_list {
      height: 100%;
      position: relative;
      .daily_item {
        // width: 100%;
        overflow: hidden;
        color: #ffffff;
        position: relative;
        margin-bottom: 40px;
        cursor: pointer;
        .item_top {
          display: flex;
          align-items: center;
          .headPhoto {
            width: 42px;
            height: 42px;
            margin-right: 10px;
          }
          .school_img {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            margin-left: 10px;
            margin-right: 3px;
          }
          .user_name {
            display: flex;
            align-items: center;
            font-size: 15px;
            color: #333333;
            span {
              display: flex;
              align-items: center;
              font-size: 12px;
              color: #666666;
            }
          }
          .user_inte {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.5);
            margin-top: 5px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .user_time {
            position: absolute;
            top: 18px;
            right: 15px;
            font-size: 12px;
            color: #999999;
          }
        }
        .daily_content {
          margin-top: 16px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          color: #333333;
          font-size: 14px;
        }
        .daily_bottom {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex-wrap: wrap;
          .daily_img {
            width: 72px;
            height: 72px;
            display: flex;
            align-items: center;
            justify-items: center;
            margin-right: 5px;
            flex-shrink: 0;
            margin-top: 5px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}

.log_modal {
  width: 770px;
  height: 660px;
  border-radius: 10px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -385px;
  margin-top: -330px;
  background: #fff;
  z-index: 1001;
  padding: 30px;
  .log_close {
    width: 40px;
    position: absolute;
    top: -60px;
    right: 20px;
    cursor: pointer;
  }
  .user_box {
    display: flex;
    align-items: center;
    .bannner_log {
      width: 345px;
      height: 180px;
      flex-shrink: 0;
      border-radius: 5px;
    }
    .user_box_log {
      margin-left: 30px;
      .log_tit {
        color: #2a2e3d;
        font-size: 20px;
        font-weight: bold;
        line-height: 26px;
      }
      .log_date {
        display: flex;
        align-items: center;
        margin-top: 15px;
        justify-content: space-between;
        .log_date_left {
          color: #bac2d1;
          font-size: 11px;
          line-height: 24px;
          span {
            font-size: 17px;
            color: #2a2e3d;
          }
        }
        .log_date_right {
          color: #07a0b5;
          font-size: 11px;
          .iconfont {
            font-size: 11px;
          }
        }
      }
      .log_info {
        width: 335px;
        background: #f8f8fa;
        border-radius: 5px;
        padding: 4px;
        display: flex;
        align-items: center;
        position: relative;
        margin-top: 20px;
        .user_img {
          width: 44px;
          height: 44px;
          margin-right: 8px;
          border-radius: 4px;
        }
        .user_info {
          .name {
            color: #727b8c;
            font-size: 13px;
            font-weight: bold;
            .iconfont {
              margin-left: 10px;
              font-size: 10px;
              font-weight: inherit;
            }
            b {
              font-weight: inherit;
              font-size: 10px;
              margin-left: 3px;
            }
          }
        }
        .info {
          color: #bac2d1;
          font-size: 11px;
          margin-top: 8px;
        }
        .log_time {
          font-size: 11px;
          color: #bac2d1;
          position: absolute;
          right: 19px;
          top: 8px;
          .iconfont {
            margin-right: 4px;
            font-size: 11px;
          }
        }
      }
    }
  }
  .fenge {
    color: #2a2e3d;
    font-size: 15px;
    font-weight: bold;
    padding: 0 10px;
    display: flex;
    align-items: center;
    margin: 15px 0;
    div:nth-child(1) {
      width: 40px;
    }
    .dashed {
      width: 100%;
      border: 1px dashed #dce0e8;
      margin-left: 5px;
      height: 1px;
    }
  }
  .log_content {
    font-size: 15px;
    color: #7c829d;
    line-height: 22px;
    overflow-y: auto;
    height: 350px;
    img {
      width: 335px;
      margin: 15px 0;
    }
    video {
      width: 100%;
      margin: 15px 0;
    }
  }
  .banner_video {
    width: 345px;
    height: 180px;
    flex-shrink: 0;
    border-radius: 5px;
  }
}
  .shade_pop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
</style>